import * as React from 'react';
import Text from '@amzn/meridian/text';
import Loader from '@amzn/meridian/loader';
import Column from '@amzn/meridian/column';
import { useEffect, useState } from 'react';
export interface PageLoaderProps {
  message: string;
  delay?: number;
}
function timeout (delay: number) {
  return new Promise(resolve => setTimeout(resolve, delay));
}
export function PageLoader (props: PageLoaderProps) {
  const { delay, message } = props;
  const [isLongWait, setIsLongWait] = useState(false);

  useEffect(() => {
    timeout(delay ?? 1000).then(() => { setIsLongWait(true); });
  }, [delay]);

  return (
    <Column alignmentHorizontal='center'>
      {isLongWait && <>
        <Text className="mb-4" type="h300">{message}</Text>
        <Loader data-testid="page-loader"/>
      </>}
    </Column>
  );
}
